export default function clone(data) {
  if (data !== undefined) {
    return JSON.parse(JSON.stringify(data));
  }

  return null;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/utils/clone.js
// module id = 605
// module chunks = 0